import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
export function MarketingLayout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="min-h-screen bg-background text-textMain font-sans selection:bg-primary/30 selection:text-primary relative" data-id="element-674">
      {/* Global Animated Aurora Background */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none z-0" data-id="element-675">
        <div className="aurora-blob absolute top-[-10%] left-[-10%] w-[50vw] h-[50vw] rounded-full bg-primary/5 blur-[120px] mix-blend-screen" data-id="element-676"></div>
        <div className="aurora-blob absolute bottom-[-10%] right-[-10%] w-[60vw] h-[60vw] rounded-full bg-purple-500/5 blur-[120px] mix-blend-screen" style={{
        animationDelay: '-5s',
        animationDuration: '25s'
      }} data-id="element-677"></div>
        <div className="aurora-blob absolute top-[40%] left-[60%] w-[40vw] h-[40vw] rounded-full bg-teal-500/5 blur-[120px] mix-blend-screen" style={{
        animationDelay: '-10s',
        animationDuration: '22s'
      }} data-id="element-678"></div>
      </div>

      <Navbar data-id="element-679" />
      <main className="relative z-10" data-id="element-680">{children}</main>
      <div className="relative z-10" data-id="element-681">
        <Footer data-id="element-682" />
      </div>
    </div>;
}